import { useContext } from 'react';
import { VigoPageContext, VigoPageContextValue } from 'src/@core/context/vigoPageContext';

export const useVigoPage = (): VigoPageContextValue => useContext(VigoPageContext);
